import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=c382cb70&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=c382cb70&prod&scoped=true&lang=scss"
import style1 from "./Chat.vue?vue&type=style&index=1&id=c382cb70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c382cb70",
  null
  
)

export default component.exports